/**
 * "Text size" in the avatar dropdown (mirrors LanguageSwitcher's menu item):
 * a submenu with Standard / Comfortable and a check on the active scale. The
 * onClick is wired at the parent menu (AppLayout), which routes
 * 'scale:<name>' keys to setTypeScale. Same switch the phone has under
 * More → App → Text size.
 */
import type { MenuProps } from 'antd';
import { CheckOutlined, FontSizeOutlined } from '@ant-design/icons';
import { TYPE_SCALES, type TypeScale } from '../theme/typeScale';

type TFn = (key: string) => string;

export function typeScaleMenuItem(
  t: TFn,
  current: TypeScale,
): NonNullable<MenuProps['items']>[number] {
  return {
    key: 'typeScale',
    icon: <FontSizeOutlined />,
    label: t('typeScale.label'),
    children: TYPE_SCALES.map((scale) => ({
      key: `scale:${scale}`,
      label: (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 140 }}>
          <CheckOutlined
            style={{
              fontSize: 'var(--t-meta)',
              color: 'var(--brand)',
              visibility: scale === current ? 'visible' : 'hidden',
            }}
          />
          <span>{t(`typeScale.${scale}`)}</span>
        </span>
      ),
    })),
  };
}
